export default () => (
    <div>
        <h1>Pepper Console, Version={import.meta.env.SERVICE_VERSION || 'UNKNOWN'}</h1>
    </div>
);
